// mavie-campaign-cart.js
(function () {
  // --- 1) 記事内 商品ブロック：価格を埋める（data-product-handle を参照） ---
  function initCampaignPrices() {
    var els = document.querySelectorAll('.product-price[data-product-handle], .product-price[data-productHandle]');
    if (!els.length) return;

    els.forEach(function (el) {
      var handle = el.dataset.productHandle || el.getAttribute('data-product-handle');
      if (!handle) return;

      fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data || !data.variants || !data.variants.length) return;

          // 価格表示：最初のvariant（※必要なら「available優先」に変更可能）
          var v = data.variants.find(function (x) { return x.available; }) || data.variants[0];
          el.textContent = '¥' + (v.price / 100).toLocaleString();
        })
        .catch(function () { });
    });
  }

  // --- 2) 記事内 カート投入：handle → product.js → available variant → cart/add.js ---
  async function fetchProductJson(handle) {
    var res = await fetch('/products/' + handle + '.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('商品情報の取得に失敗しました');
    return res.json();
  }

  function pickVariant(product) {
    // 基本：購入可能(available)の先頭
    // ※「古い年から売る」は運用（販売可能にする在庫だけを出す）で制御するのが最も事故が少ないです
    var v = (product.variants || []).find(function (x) { return x.available; });
    return v || null;
  }

  async function addToCart(variantId, qty) {
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: variantId, quantity: qty })
    });
    if (!res.ok) throw new Error('カート追加に失敗しました');
    return res.json();
  }

  function initCampaignAddToCart() {
    document.addEventListener('click', async function (e) {
      var btn = e.target.closest('a.js-mavie-add');
      if (!btn) return;

      e.preventDefault();

      var handle = btn.dataset.handle;
      var qty = parseInt(btn.dataset.qty || '1', 10) || 1;

      try {
        btn.classList.add('is-loading');

        var product = await fetchProductJson(handle);
        var v = pickVariant(product);
        if (!v) throw new Error('在庫がありません');

        await addToCart(v.id, qty);

        // 追加後はカートへ（ミニカート連動があるならここを差し替え）
        window.location.href = '/cart';
      } catch (err) {
        // 失敗時は商品ページへ（保険）
        window.location.href = btn.getAttribute('href') || ('/products/' + handle);
      } finally {
        btn.classList.remove('is-loading');
      }
    }, false);
  }

  // 実行
  document.addEventListener('DOMContentLoaded', function () {
    initCampaignPrices();
    initCampaignAddToCart();
  });
})();
